<template>
   <v-container fluid>
      <v-row>
         <v-col cols="12">
            <v-toolbar dense color="primary white--text" bottom>
               <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                  Manage Group
               </v-toolbar-title>
               <v-icon color="white" v-else>mdi-folder</v-icon>

               <v-spacer></v-spacer>
               <v-toolbar-items class="pa-2">
                  <v-card max-width="250px" flat color="primary">
                     <keep-alive>
                        <v-select
                           dark
                           v-model="termyearselect"
                           :items="termyear"
                           item-text="termyeartext"
                           item-value="id"
                           label="Select"
                           return-object
                           single-line
                           @change="changeTerm"
                        >
                        </v-select>
                     </keep-alive>
                  </v-card>
               </v-toolbar-items>
            </v-toolbar>
            <v-toolbar>
               <v-btn
                  :disabled="!$globalstore.UserHasCap(CapConstant.CREATE_GROUP)"
                  class="ma-2"
                  small
                  outlined
                  color="indigo"
                  @click="createGroup()"
               >
                  <v-icon left>mdi-plus</v-icon>
                  <div v-if="$vuetify.breakpoint.mdAndUp">Create</div>
               </v-btn>
            </v-toolbar>
         </v-col>
      </v-row>
      <v-row no-gutters>
         <v-col md="12">
            <v-card class="overflow-y-auto">
               <v-card-title class="py-0">
                  <v-text-field
                     class="mb-2"
                     v-model="table_search"
                     append-icon="mdi-magnify"
                     label="Search"
                     single-line
                     hide-details
                     clearable
                  ></v-text-field>
               </v-card-title>
               <v-data-table
                  dense
                  fixed-header
                  height="60vh"
                  :headers="table_headers"
                  :items="ccagroups"
                  :search="table_search"
                  item-key="cca_id"
                  :options.sync="pagination"
                  @click:row="groupRowClick"
                  single-select
                  :items-per-page="itemPageCount"
                  @update:items-per-page="itemPerPageChange"
               >
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.cca_description="{item}">
                     {{ item.cca_description | ellipsetext(40) }}
                  </template>
                  <!-- eslint-disable-next-line -->
                  <template v-slot:item.actions="{item}">
                     <v-icon small class="mr-2" @click="editGroup(item)">
                        mdi-pencil
                     </v-icon>
                     <v-icon small class="mr-2" @click="deleteGroup(item)">
                        mdi-delete
                     </v-icon>
                     <v-icon
                        v-if="$globalstore.UserHasCap(CapConstant.COPY_GROUP)"
                        small
                        class="mr-2"
                        @click="copyGroup(item)"
                     >
                        mdi-content-copy
                     </v-icon>
                  </template>
               </v-data-table>
            </v-card>
         </v-col>
      </v-row>
      <copy-group ref="copyform" @input="copyGroupFormClose"></copy-group>
      <confirm-dlg ref="confirm"></confirm-dlg>
      <show-toast ref="toast"></show-toast>
   </v-container>
</template>

<script>
   import CapConstant from "@/common/capconstant.js";
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import CopyGroup from "@/components/CopyGroup.vue";
   import ShowToast from "@/components/showToast.vue";

   export default {
      inject: ["ShowMessage"],

      components: {
         ConfirmDlg,
         CopyGroup,
         ShowToast,
      },
      data() {
         return {
            CapConstant: Object.freeze(CapConstant),
            searchGroup: "",
            termyearselect: null,
            termyear: [],
            ccagroups: [],
            pagination: {},
            table_search: "",
            itemPageCount: this.$globalstore.ccagroup.itemsperpage || 10,
            table_headers: [
               {
                  text: "Group Name",
                  align: "start",
                  value: "cca_name",
                  width: "300px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Description",
                  value: "cca_description",
                  width: "300px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Day/Time",
                  value: "daytime",
                  width: "150px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Schedule",
                  value: "schedule_name",
                  width: "250px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "150px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Fee",
                  value: "cca_fee",
                  width: "100px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Sub",
                  align: "end",
                  value: "participantcount",
                  width: "80px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Wait",
                  align: "end",
                  value: "waitlistcount",
                  width: "80px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "Max",
                  align: "end",
                  value: "max_participant",
                  width: "80px",
                  class: this.$globalstore.table_smallheaderclass,
               },
               {
                  text: "",
                  value: "actions",
                  width: "200px",
                  class: this.$globalstore.table_smallheaderclass,
               },
            ],
         };
      },

      methods: {
         itemPerPageChange(count) {
            this.$globalstore.ccagroup.itemsperpage = count;
         },

         groupRowClick(item, row) {
            row.select(!row.isSelected);
         },

         createGroup() {
            this.$router.push({
               name: "AddGroup",
               params: {termyear: this.termyearselect},
            });
         },

         editGroup(item) {
            this.$globalstore.ccagroup.ccagroupdata = this.ccagroups.slice();
            this.$globalstore.ccagroup.page = this.pagination.page;

            this.$router.push({
               name: "EditGroup",
               params: {groupid: item.cca_id},
            });
         },

         deleteGroup(item) {
            if (item.participantcount > 0 || item.waitlistcount > 0) {
               this.ShowMessage({
                  title: "Error",
                  message: item.cca_name + " has subscribers and cannot be deleted.",
                  color: "red",
               });
            } else {
               this.$refs.confirm
                  .open("Warning", "Are you sure you want to delete " + item.cca_name + "?", {
                     color: "orange",
                  })
                  .then((reply) => {
                     if (reply) {
                        this.doDeleteGroup(item);
                     }
                  });
            }
         },

         async doDeleteGroup(item) {
            await this.$http({
               url: "/cca/removegroup.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: item.cca_id,
                  token: this.$globalstore.user.usertoken,
                  userid: this.$globalstore.user.userid,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                     this.GetCCAGroupList();
                  }
               }
            });
         },

         async copyGroupFormClose(payload) {
            await this.$http({
               url: "/cca/copygroupdata.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  groupdata: payload,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         copyGroup(item) {
            this.$refs.copyform.open(item);
         },

         SetTermYear() {
            if (this.termyear.length > 0) {
               if (this.$globalstore.currentyear && this.$globalstore.currentterm) {
                  this.termyearselect = this.termyear.find(
                     (x) =>
                        x.year == this.$globalstore.currentyear &&
                        x.term == this.$globalstore.currentterm
                  );
               } else {
                  this.termyearselect = this.termyear.find(
                     (x) => x.id == this.$globalstore.appsettings.currentyearterm.id
                  );
               }
            }
         },

         async GetCCAGroupList() {
            await this.$http({
               url: "/cca/ccaGroupList.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  year: this.termyearselect.year,
                  term: this.termyearselect.term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                     this.ccagroups = [];
                  } else {
                     this.$globalstore.ccagroup.page = null;
                     this.$globalstore.ccagroup.ccagroupdata = [];
                     this.ccagroups = response.data.groupdata;
                  }
               }
            });
         },

         changeTerm(ytobj) {
            if (ytobj) {
               this.$globalstore.currentyear = ytobj.year;
               this.$globalstore.currentterm = ytobj.term;
               this.GetCCAGroupList();
            }
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.termyear = this.$globalstore.termyearlist;
            this.SetTermYear();
            if (this.$globalstore.ccagroup.page && this.$globalstore.ccagroup.page > 1) {
               this.ccagroups = this.$globalstore.ccagroup.ccagroupdata.slice();
               this.pagination.page = this.$globalstore.ccagroup.page;
            } else {
               await this.GetCCAGroupList();
            }
         }
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
